import React from "react";
import * as c from "./ctaSection.module.scss";
import classNames from "classnames";
import { ContentfulCta } from "@components/shared/cta";
import { graphql, useStaticQuery } from "gatsby";
import { ResponsiveImage } from "@components/shared/responsiveImage";
import VideoModal from "@components/shared/videoModal/videoModal";

const CTASection = ({ className, heading, ctas, image }) => {
  // Temp. while Contentful entries all get republished -- this should get queried by consumers
  // Remove once all Contentful entries have been republished
  const { tempDefault } = useStaticQuery(graphql`
    query {
      tempDefault: contentfulLandingPageSectionFooterCta(contentfulName: { eq: "default" }) {
        ...ctaSectionFields
      }
    }
  `);

  if (!image) {
    heading = tempDefault?.heading;
    ctas = tempDefault?.ctas;
    image = tempDefault?.image;
  }

  const [firstCTA, secondCTA, thirdCTA] = ctas;
  return (
    <>
      <section className={classNames(c.container, className)} data-transition="slide-enter">
        <div className={c.text}>
          <h2 className={classNames(c.heading, "h3")}>{heading}</h2>
          <div className={c.buttonRow}>
            {firstCTA && <ContentfulCta {...firstCTA} size="large" />}
            {secondCTA && <ContentfulCta {...secondCTA} size="large" />}
          </div>
          {thirdCTA && thirdCTA.wistiaVideoId ? (
            // Let's show the video modal CTA if there's a video ID present for the third CTA
            <VideoModal label={"Watch a video tour"} id={"cta-modal"} />
          ) : thirdCTA ? (
            <ContentfulCta className={c.link} {...thirdCTA} />
          ) : null}
        </div>
        <div className={c.visual}>
          <ResponsiveImage className={c.image} images={image} alt="" />
        </div>
      </section>
    </>
  );
};

const ctaSectionFields = graphql`
  fragment ctaSectionFields on ContentfulLandingPageSectionFooterCta {
    id
    heading
    ctas {
      __typename
      ... on ContentfulCtaButton {
        label
        isExternal
        url
        showIcon
        trackedEventName
        style
        openChat
      }
      ... on ContentfulCtaVideoModal {
        label
        showIcon
        wistiaVideoId
        trackedEventName
        style
      }
    }
    image {
      ... on ContentfulResponsiveImage {
        xxl {
          gatsbyImageData(width: 540, quality: 90, layout: CONSTRAINED)
        }
        md {
          gatsbyImageData(width: 270, quality: 90, layout: CONSTRAINED)
        }
        sm {
          gatsbyImageData(width: 330, quality: 90, layout: CONSTRAINED)
        }
      }
    }
  }
`;

export { CTASection, ctaSectionFields };
